
import { useEffect } from "react";
import { useRecoilState } from 'recoil'
import { CookieBannerState } from 'state/CookieBannerState';
import CookieConsent, { Cookies } from "react-cookie-consent";
import { BlurLayout } from 'components/blurlayout/BlurLayout';
import { useTranslations } from "hooks";

/**
 * 
 * description
 * 
* ###Import to use it
*
*```jsx
*   import { ButtonSubmit } from './ButtonSubmit'
*```
*
*### Usage
*
*```jsx
*<ButtonSubmit 
*   label={string} 
*   isSubmit={boolean} 
*   disabled={boolean}
/>
*```
*
*### Basic Example
*/

const i18n = [
    'ReactLib.RGPD.consentMessage.text',
    'ReactLib.RGPD.redirectOnDeclineMessage.text',
    'ReactLib.RGPD.Accept.button',
    'ReactLib.RGPD.Decline.button',
    'ReactLib.RGPD.Privacy.Link.text',
    'ReactLib.RGPD.Privacy.Link.href',
]

export const CookieBanner = () => {
    /** Split the whitelist sites into an array */
    const whiteListSites: Array<string> | undefined = process.env.REACT_APP_WEBSITE_RGPD_WHITE_LIST?.split('|');
    /** Get the refferrer and store the domain name only */
    const referrerDomainName: string = document.referrer.split('/')[2]


    const cookieName: string = `${process.env.REACT_APP_ECO_APP_NAME}-cookie-consent`
    const [banner, setBanner] = useRecoilState<boolean>(CookieBannerState)

    useEffect(() => {
        if (whiteListSites?.includes(referrerDomainName) || Cookies.get(cookieName)) {
            Cookies.set(cookieName, 'true')
            return setBanner(banner === false)
        }
    }, [setBanner])

    const handleAcceptCookie = () => setBanner(banner === false)

    const handleDeclineCookie = () => {
        Cookies.remove(cookieName);

        if (!Cookies.get(cookieName)) {
            window.location.href = `${process.env.REACT_APP_SDS_ONE_CLICK_URL}`
        }
    }

    const [
        CONSENT_TEXT,
        CONSENT_REDIRECT_TEXT,
        ACCEPT,
        DECLINE,
        LINK_TEXT,
        LINK_HREF

    ] = useTranslations(i18n)

    return (
        <BlurLayout isActivated={banner}>
            <CookieConsent
                cookieName={cookieName}
                buttonText={ACCEPT}
                location={"bottom"}
                style={{ background: "#2c72ab" }}
                buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                enableDeclineButton
                onAccept= {handleAcceptCookie}
                onDecline={handleDeclineCookie}
                declineButtonText={DECLINE}
                expires={150}
                debug
            >
                {CONSENT_TEXT}
                <a href={LINK_HREF} target="_blank" rel="noopener" style={{ marginLeft: "5px", color: "white" }}>
                    {LINK_TEXT}
                </a>.
                <span style={{ fontSize: "10px" }}> {CONSENT_REDIRECT_TEXT}</span>
            </CookieConsent>
        </BlurLayout>
    );
}